const MIME_TYPES: Record<string, string> = {
  py: 'text/x-python',
  json: 'application/json',
  csv: 'text/csv',
  pem: 'application/x-pem-file',
  crt: 'application/x-x509-ca-cert',
  md: 'text/markdown',
};

export const createFileBlob = (content: string, fileName: string): Blob => {
  const ext = fileName.split('.').pop()?.toLowerCase() ?? '';
  const mimeType = MIME_TYPES[ext] ?? 'text/plain';
  return new Blob([content], { type: mimeType });
};
